/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../../theme/theme';
import {IconProps, IconSize} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Top Nav Notifications Icon component.
 */
export const TopNavNotificationIcon = ({
  size = IconSize.large,
  color = dlsColor('grey1')
}: IconProps) => {
  const {iconSize, iconColor} = useIconDLS({color, size});
  return (
    <svg width='19' height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M18.6994 12.3516V8.33955C18.7205 6.48019 18.015 4.68365 16.7281 3.31987C15.4413 1.95608 13.6711 1.12886 11.782 1.00855C10.7992 0.96125 9.81689 1.11062 8.89467 1.44756C7.97246 1.78451 7.12955 2.302 6.41714 2.96866C5.70473 3.63531 5.13766 4.43723 4.75036 5.3257C4.36305 6.21417 4.16358 7.17067 4.16406 8.13716V12.3516C4.17124 13.2395 3.90949 14.1095 3.41207 14.8509C3.14331 15.2407 2.99976 15.7007 3 16.1714V16.1714C3 16.4861 3.0632 16.7977 3.18595 17.0884C3.30871 17.379 3.48861 17.6431 3.71539 17.8654C3.94217 18.0876 4.21136 18.2638 4.50753 18.3838C4.80371 18.5037 5.12108 18.5651 5.44145 18.5645H17.422C17.7423 18.5651 18.0597 18.5037 18.3559 18.3838C18.6521 18.2638 18.9213 18.0876 19.148 17.8654C19.3748 17.6431 19.5547 17.379 19.6775 17.0884C19.8002 16.7977 19.8634 16.4861 19.8634 16.1714V16.1714C19.8637 15.7007 19.7201 15.2407 19.4514 14.8509C18.9539 14.1095 18.6922 13.2395 18.6994 12.3516V12.3516Z' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M13.9608 20.2695C13.9608 20.9284 13.6944 21.5602 13.2201 22.0261C12.7458 22.4919 12.1026 22.7537 11.4318 22.7537C10.7611 22.7537 10.1178 22.4919 9.64354 22.0261C9.16927 21.5602 8.90283 20.9284 8.90283 20.2695' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
};

export default TopNavNotificationIcon;
